// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymentError_container__DvY4a","text-advice":"PaymentError_text-advice__NH1n0"};